import { MenuPassThroughOptions } from 'primereact/menu';
import { classNames } from 'primereact/utils';

const TRANSITIONS = {
  overlay: {
    timeout: 150,
    classNames: {
      enter: 'opacity-0 scale-75',
      enterActive:
        'opacity-100 !scale-100 transition-transform transition-opacity duration-150 ease-in',
      exit: 'opacity-100',
      exitActive: '!opacity-0 transition-opacity duration-150 ease-linear',
    },
  },
};

export const PTMenu: MenuPassThroughOptions = {
  root: {
    className:
      'pt-1 bg-white text-gray-700 rounded-2xl shadow-lg w-72 z-[1081]!',
  },
  menu: {
    className: classNames('m-0 p-3 list-none rounded-2xl', 'outline-none'),
  },
  content: () => ({
    className: classNames(
      'text-teal transition-shadow duration-200 rounded-2xl',
      'hover:text-blue! hover:bg-cream', // Hover
    ),
  }),
  action: {
    className: classNames(
      'text-teal py-3 px-5 select-none',
      'cursor-pointer flex items-center no-underline overflow-hidden relative',
    ),
  },
  menuitem: {
    className: classNames(
      'text-teal font-normal py-2 px-3 cursor-pointer leading-1',
      'hover:bg-cream rounded-xl',
      'hover:text-blue!',
      'first:rounded-t-2xl',
      'last:rounded-b-2xl',
    ),
  },
  icon: {
    className: 'text-teal mr-2',
  },
  submenuHeader: {
    className: classNames(
      'm-0 py-2 px-1 text-teal bg-white font-medium rounded-t-2xl',
    ),
  },
  separator: {
    className: 'border-t border-gray-light my-1',
  },
  transition: TRANSITIONS.overlay,
};
